export default "__VITE_ASSET__CCL6KqjR__"